import React from 'react';
import { modalStyles } from 'utils/modalDesignSystem';

const StatusMessage = ({ type, children, show = false }) => {
  const typeStyles = type === 'success' 
    ? modalStyles.statusMessageSuccess 
    : modalStyles.statusMessageError;

  return (
    <div style={{
      ...modalStyles.statusMessage,
      ...typeStyles,
      ...(show ? modalStyles.statusMessageActive : {})
    }}>
      {children}
    </div>
  );
};

export default StatusMessage;
